import React from 'react';

function CreativeT() {
  return <div></div>;
}

export default CreativeT;
